const apiKey = process.env

async function getAllHospitals(page) {
  const apiUrl = apiKey.REACT_APP_API_URL
  const data = await fetch(`${apiUrl}/getAllHospitals/${page}`)
  const result = await data.json()
  return result;
}

module.exports = {getAllHospitals};